import {getDateDDMMYYUtc} from "./timestampService";

export function getHistoryByDaySum(history) {
    const locHistory = history.sort(sortHistory);
    let convertingHistory = [];

    locHistory.forEach((item, index) => {
        const nexDay = locHistory[index + 1]
        if(nexDay &&  !compareDate(nexDay.Date, item.Date)) {
            convertingHistory.push({
                Date : item.Date,
                Bet: item.Bet,
                Win: item.Win,
                Prediction: item.Prediction,
                startDay: true
            })
        } else {
            convertingHistory.push({
                Date : item.Date,
                Bet: item.Bet,
                Win: item.Win,
                Prediction: item.Prediction,
            })
        }


    })

    return convertingHistory
}

export function sortHistory(a,b) {
    return new Date(b.Date).getTime() - new Date(a.Date).getTime()
}


export function compareDate(dateA, dateB) {
    return getDateDDMMYYUtc(dateA) === getDateDDMMYYUtc(dateB)
}
